import {Env} from "../../../config";

const API_URL = Env.REACT_APP_API_URL
const apiUrl = (path: String) => `${API_URL}${path}`;


export {API_URL, apiUrl}
